import React, { useState, useEffect } from 'react';
import { Box, Typography, Container } from '@mui/material';

// Set target date outside of the component to avoid resetting
const targetDate = new Date().getTime() + 6 * 24 * 60 * 60 * 1000;

const ComingSoon = () => {
  const calculateTimeLeft = () => {
    const difference = targetDate - new Date().getTime();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    } else {
      timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (time) => (time < 10 ? `0${time}` : time);

  return (
    <Container
      maxWidth="lg"
      sx={{
        height: '95vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        background: 'linear-gradient(to right, #8360c3, #2ebf91)',
        color: '#fff',
        borderRadius: '10px',        
      }}
    >
      <Typography
        variant="h2"
        gutterBottom
        sx={{ fontWeight: 'bold', fontSize: '3rem', marginBottom: '20px' }}
      >
        Feature Coming Soon
      </Typography>
      <Typography variant="body1" sx={{ fontSize: '1.2rem', marginBottom: '30px' }}>
        We are working on some features. Please check back soon!
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'rgba(255, 255, 255, 0.1)',
          padding: '10px 20px',
          borderRadius: '10px',
        }}
      >
        <Box sx={{ margin: '0 10px', textAlign: 'center' }}>
          <Typography variant="h4">{formatTime(timeLeft.days)}</Typography>
          <Typography variant="subtitle2">Days</Typography>
        </Box>
        <Box sx={{ margin: '0 10px', textAlign: 'center' }}>
          <Typography variant="h4">{formatTime(timeLeft.hours)}</Typography>
          <Typography variant="subtitle2">Hours</Typography>
        </Box>
        <Box sx={{ margin: '0 10px', textAlign: 'center' }}>
          <Typography variant="h4">{formatTime(timeLeft.minutes)}</Typography>
          <Typography variant="subtitle2">Minutes</Typography>
        </Box>
        <Box sx={{ margin: '0 10px', textAlign: 'center' }}>
          <Typography variant="h4">{formatTime(timeLeft.seconds)}</Typography>
          <Typography variant="subtitle2">Seconds</Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default ComingSoon;
